import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { LoginShareServices } from "./services/loginShareService.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  href: string = "";
  showSideBar: Boolean = false;

  public appPages = [
    { title: "المستخدمين", url: "users", icon: "paper-plane" },
    { title: "القوانين النافذة", url: "laws", icon: "heart" },
    { title: "مبادئ المحكمة العليا", url: "books", icon: "heart" },
    { title: "تصفية الشركات ", url: "liqudations", icon: "archive" },
    { title: " الاحصائيات", url: "stats", icon: "trash" },
    { title: " الاشتراكات", url: "subscription", icon: "trash" },
    { title: "المكتبة ", url: "media", icon: "heart" },
    { title: "النقاشات  ", url: "discussions", icon: "archive" },
    { title: " الشروط والأحكام", url: "terms", icon: "trash" },
  ];

  public labels = ["Family", "Friends", "Notes", "Work", "Travel", "Reminders"];

  arr: any = [];
  constructor(
    private router: Router,
    private loginShareService: LoginShareServices
  ) {}

  ngOnInit() {
    this.loginShareService.currentObject.subscribe(
      (showSideBar) => (this.showSideBar = showSideBar)
    );

    const userData = JSON.parse(localStorage.getItem("user"));
    const isLoggedIn = userData?.result?.accessToken ? true : false;
    console.log(isLoggedIn);

    // if (isLoggedIn) {
    //   this.showSideBar = true;
    // } else {
    //   this.showSideBar = false;
    // }
  }
}
